import React from "react";
import "./../styles/products.css";

const Produtos = () => {
  return (
    <section className="container">
      <div className="page-padding mt-10 relative" id="produtos">
        <div className="flex justify-center">
          <h1 className="text-slate-700 font-semibold text-3xl">Produtos</h1>
        </div>
        <div className="products-grid grid grid-cols-4 grid-rows-2 gap-7 h-full mt-7">
          <div className="item-0 relative">
            <div className="absolute z-10 bottom-10 left-10">
              <p className="text-[#c32621] text-[2rem] font-bold">Notebooks</p>
            </div>
          </div>
          <div className="item-1 relative shadow-xl">
            <div className="absolute z-10 bottom-10 left-10">
              <p className="text-[#c32621] text-[2rem] font-bold">Desktop</p>
            </div>
          </div>
          <div className="item-2 relative shadow-xl">
            <div className="absolute z-10 bottom-10 left-10">
              <p className="text-[#c32621] text-[2rem] font-bold">
                Periféricos
              </p>
            </div>
          </div>
          <div className="item-3 relative shadow-xl">
            <div className="absolute z-10 bottom-10 left-10">
              <p className="text-[#c32621] text-[2rem] font-bold">Servidor</p>
            </div>
          </div>
          <div className="item-4 relative shadow-xl">
            <div className="absolute z-10 bottom-10 left-10">
              <p className="text-[#c32621] text-[2rem] font-bold">Cabeamento</p>
            </div>
          </div>
          <div className="item-5 relative shadow-xl">
            <div className="absolute z-10 bottom-10 left-10">
              <p className="text-[#c32621] text-[2rem] font-bold">HD</p>
            </div>
          </div>
          <div className="item-6 relative shadow-xl">
            <div className="absolute z-10 bottom-10 left-10">
              <p className="text-[#c32621] text-[2rem] font-bold">SSD</p>
            </div>
          </div>
          <div className="item-7 relative shadow-xl">
            <div className="absolute z-10 bottom-10 left-10">
              <p className="text-[#c32621] text-[2rem] font-bold ">GPU</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center">
        <h1 className="text-slate-700 font-medium text-2xl mt-8">
          Acesse a nossa loja clicando{" "}
          <a
            href="https://mwoutlet.mercadoshops.com.br"
            className="text-red-400"
          >
            aqui
          </a>
        </h1>
      </div>
    </section>
  );
};

export default Produtos;
